import { getSpecialCharactersRegex } from '@pe-libs/react-components/build/lib/helper';
import yup from '#schema/locale';

const PeOnboardingSchemaPage1 = yup.object({
  salutation: yup.string().trim(),
  title: yup.string().trim(),
  externalAuth: yup.bool(),
  firstName: yup
    .string()
    .required()
    .max(100)
    .matches(getSpecialCharactersRegex('-'))
    .trim(),
  lastName: yup
    .string()
    .required()
    .max(100)
    .matches(getSpecialCharactersRegex('-'))
    .trim(),
  password: yup.string().when('externalAuth', {
    is: false,
    then: (schema: yup.StringSchema) =>
      schema
        .required()
        .min(10, 'length')
        .max(512)
        .matches(/(?=.*?[A-ZÀ-ÖØ-Þ])/, 'uppercase')
        .matches(/(?=.*?[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])/, 'special')
        .matches(/(?=.*?\d)/, 'number')
        .trim(),
  }),
});

export default PeOnboardingSchemaPage1;
